import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

function RegisterPage({ handleRegister }) {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [nombre, setNombre] = useState("");
  const [telefono, setTelefono] = useState("");
  const [direccion, setDireccion] = useState("");
  const [pais, setPais] = useState("");
  const [fechaNacimiento, setFechaNacimiento] = useState("");

  const onSubmit = async () => {
    if (!email || !password || !confirmPassword || !nombre) {
      alert("Por favor completa los campos obligatorios");
      return;
    }
    if (password !== confirmPassword) {
      alert("Las contraseñas no coinciden");
      return;
    }

    await handleRegister(
      email,
      password,
      nombre,
      telefono,
      direccion,
      pais,
      fechaNacimiento
    );

    navigate("/profile");
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "calc(100vh - 120px)",
        backgroundColor: "#f5f5f5",
        fontFamily: "'Inter', sans-serif",
      }}
    >
      <div
        style={{
          maxWidth: "420px",
          width: "90%",
          backgroundColor: "#fff",
          borderRadius: "10px",
          padding: "30px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          position: "relative",
        }}
      >
        <FaArrowLeft
          onClick={() => navigate(-1)}
          title="Volver"
          style={{
            position: "absolute",
            top: "15px",
            left: "15px",
            color: "#4B6CB7",
            fontSize: "18px",
            cursor: "pointer",
            transition: "color 0.2s ease",
          }}
          onMouseOver={(e) => (e.target.style.color = "#324b8a")}
          onMouseOut={(e) => (e.target.style.color = "#4B6CB7")}
        />

        <h2
          style={{
            textAlign: "center",
            marginBottom: "20px",
            fontWeight: "600",
            color: "#000",
          }}
        >
          Crear cuenta
        </h2>

        <input
          type="text"
          placeholder="Nombre completo"
          value={nombre}
          onChange={(e) => setNombre(e.target.value)}
          style={inputStyle}
        />
        <input
          type="email"
          placeholder="Correo electrónico"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={inputStyle}
        />
        <input
          type="tel"
          placeholder="Teléfono"
          value={telefono}
          onChange={(e) => setTelefono(e.target.value)}
          style={inputStyle}
        />
        <input
          type="text"
          placeholder="Dirección"
          value={direccion}
          onChange={(e) => setDireccion(e.target.value)}
          style={inputStyle}
        />
        <input
          type="text"
          placeholder="País"
          value={pais}
          onChange={(e) => setPais(e.target.value)}
          style={inputStyle}
        />
        <label style={{ fontSize: "14px", marginBottom: "5px" }}>
          Fecha de nacimiento
        </label>
        <input
          type="date"
          value={fechaNacimiento}
          onChange={(e) => setFechaNacimiento(e.target.value)}
          style={inputStyle}
        />
        <input
          type="password"
          placeholder="Contraseña"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={inputStyle}
        />
        <input
          type="password"
          placeholder="Repetir contraseña"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          style={inputStyle}
        />

        <button
          onClick={onSubmit}
          style={{
            width: "100%",
            padding: "12px",
            backgroundColor: "#4B6CB7",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontWeight: "500",
          }}
        >
          Registrarse
        </button>

        <button
          onClick={() => navigate("/")}
          style={{
            width: "100%",
            padding: "12px",
            marginTop: "10px",
            backgroundColor: "#ccc",
            color: "black",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontWeight: "500",
          }}
        >
          Cancelar
        </button>
      </div>
    </div>
  );
}

const inputStyle = {
  width: "100%",
  marginBottom: "10px",
  padding: "10px",
  borderRadius: "5px",
  border: "1px solid #ccc",
  outline: "none",
};

export default RegisterPage;
